var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    clipPath: "url(#clip0_2658_6342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6134 15.5151C19.0659 13.5331 19.7164 11.0758 19.4349 8.63481C19.1534 6.1938 17.9605 3.94909 16.0951 2.34978C14.2296 0.750464 11.8291 -0.085512 9.37368 0.0090977C6.91832 0.103707 4.58921 1.12193 2.85233 2.86004C1.11546 4.59816 0.098907 6.928 0.00605427 9.38343C-0.0867985 11.8389 0.750895 14.2388 2.35154 16.1031C3.95219 17.9675 6.19775 19.1587 8.63896 19.4385C11.0802 19.7182 13.537 19.0659 15.5179 17.6121H15.5164C15.5614 17.6721 15.6094 17.7291 15.6634 17.7846L21.4384 23.5596C21.7197 23.841 22.1012 23.9992 22.4991 23.9994C22.8971 23.9995 23.2787 23.8416 23.5602 23.5603C23.8416 23.2791 23.9998 22.8975 24 22.4996C24.0001 22.1017 23.8422 21.72 23.5609 21.4386L17.7859 15.6636C17.7323 15.6093 17.6746 15.5592 17.6134 15.5136V15.5151ZM18.0004 9.74908C18.0004 10.8325 17.787 11.9053 17.3724 12.9062C16.9578 13.9072 16.3501 14.8166 15.5841 15.5827C14.818 16.3488 13.9085 16.9565 12.9076 17.3711C11.9066 17.7857 10.8338 17.9991 9.75043 17.9991C8.66703 17.9991 7.59423 17.7857 6.59329 17.3711C5.59236 16.9565 4.68288 16.3488 3.9168 15.5827C3.15072 14.8166 2.54303 13.9072 2.12843 12.9062C1.71382 11.9053 1.50043 10.8325 1.50043 9.74908C1.50043 7.56105 2.36963 5.46263 3.9168 3.91545C5.46398 2.36828 7.5624 1.49908 9.75043 1.49908C11.9385 1.49908 14.0369 2.36828 15.5841 3.91545C17.1312 5.46263 18.0004 7.56105 18.0004 9.74908Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2658_6342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.52d3b19060d4fa1e415c1776f209874f.svg";
export { ForwardRef as ReactComponent };